/****************************************/
var shop_storage = {
  'selected': 0
}
/****************************************/

/****************************************/
function shopLoad(object){
  
  storage = {
    'product': {
      'dimensions': {
        'w': 0,
        'h': 0
      },
      'description': {
        'h': 0,
      }
    }
  };
  
  /* -- Load Content -- */
  if(object.type == "load"){
    
    /* -- Control(s) -- */
    $(".product.details>.column.one>.controls>.arrows.prev, .product.details>.column.one>.controls>.arrows.next, .product.details>.column.one>.controls>.pickers>.picker").click(function(){
      shopLoad({'type': "controls", 'action': $(this).attr("data-control"), 'selected': $(this).attr("data-selected")  });
    });
    
    shopLoad({'type': "display"});
    $(".product.details>.column.two, .product.details>.column.one").animate({'opacity': 1}, 500);
  }
  
  /* -- Controls -- */
  if(object.type == "controls"){
   
    /* -- Next -- */
    if(object.action == "next"){
      shop_storage.selected++;
    }
    
    /* -- Prev -- */
    if(object.action == "prev"){
      shop_storage.selected--;
    }
    
    /* -- Selected -- */
    if(object.action == "selected"){
      shop_storage.selected = parseInt(object.selected);
    }
    
    /* -- Display -- */
    shopLoad({'type': "display"});
    
  }
  
  /* -- Display -- */
  if(object.type == "display"){
    
    /* -- Arrow(s) -- */
    $(".product.details>.column.one>.controls>.arrows.prev, .product.details>.column.one>.controls>.arrows.next, .product.details>.column.one>.controls>.pickers>.picker").css({'display': "block"});
    
    if(shop_storage.selected == 0){
      $(".product.details>.column.one>.controls>.arrows.prev").css({'display': "none"});
    }
    if($(".product.details>.column.one>ul>li").length <= 1 || shop_storage.selected == ($(".product.details>.column.one>ul>li").length-1)){
      $(".product.details>.column.one>.controls>.arrows.next").css({'display': "none"});
    }
    
    /* -- Pickers -- */
    if($(".product.details>.column.one>ul>li").length == 1){
      $(".product.details>.column.one>.controls>.pickers>.picker").css({'display': "none"});
    }
    
    $(".product.details>.column.one>.controls>.pickers>.picker").removeClass("selected");
    $(".product.details>.column.one>.controls>.pickers>.picker:nth-child("+(shop_storage.selected+1)+")").addClass("selected");
    
    
    /* -- Page Display -- */
    if(environment_array.screen.w >= 850){
      $(".product").css({'min-height': (environment_array.screen.h-( $(".site-header").height())) });
      $(".product.details>.column.one").css({'height': (environment_array.screen.h-($(".site-header").height()+20)) });
      $(".product.details>.column.one>ul, .product.details>.column.one>.controls").css({'height': (environment_array.screen.h-($(".site-header").height()+70)) });
      $(".product.details>.column.one>ul>li").css({'width': $(".product.details>.column.one").width() });
      
      /* -- Scroll height -- */
      storage.product.description.h  = environment_array.screen.h;
      storage.product.description.h -= $(".site-header").height();
      storage.product.description.h -= $(".product.details>.column.two>.breadcrumb").height();
      storage.product.description.h -= $(".product.details>.column.two>h1").height();
      storage.product.description.h -= $(".product.details>.column.two>.inner>.price-custom").height();
      storage.product.description.h -= 200;
      
      $(".product.details>.column.two>.inner>.description-custom").css({'max-height': storage.product.description.h });
    }else{
      $(".product").css({'min-height': (environment_array.screen.h-( $(".site-header").height() )) });
      $(".product.details>.column.one, .product.details>.column.one>ul, .product.details>.column.one>.controls").css({'height': $(".product.details>.column.one").width() });
      $(".product.details>.column.one>ul>li").css({'width': $(".product.details>.column.one").width() });   
      $(".product.details>.column.two>.inner>.description-custom").css({'height': 'auto' });
    }
    
    /* -- Image Positions -- */
    $(".product.details>.column.one>ul").css({'margin-left': -( $(".product.details>.column.one").width()*shop_storage.selected ) });
    
    /* -- Image Resizing -- */
    $(".product.details>.column.one>ul>li").each(function(){
      storage.product.dimensions.w = Math.ceil(calculateAspectRatioFit({'required': "width", 'original_w': $(this).find("img").attr("data-ratio-w"), 'original_h': $(this).find("img").attr("data-ratio-h"), 'max_w': 10000, 'max_h': $(this).height() }));;
      storage.product.dimensions.h = Math.ceil(calculateAspectRatioFit({'required': "height", 'original_w': $(this).find("img").attr("data-ratio-w"), 'original_h': $(this).find("img").attr("data-ratio-h"), 'max_w': $(this).width(), 'max_h': 10000 }));;
      $(this).find("img").css(
        {
          'width': storage.product.dimensions.w,
          'height': storage.product.dimensions.h
        }
      );
    });
    
  }
  
}
/****************************************/

/****************************************/
$(window).resize(function() {
  
  /* -- Shop Responsive -- */
  shopLoad({'type': "display"});
  
});
/****************************************/

/****************************************/
$(window).bind("load", function() {
  setTimeout(function() {
    
    /* -- Shop Setup -- */
    shopLoad({'type': "load"});
    
  }, 100);
});
/****************************************/